var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.id)?_c('EventForm',{attrs:{"id":_vm.$route.params.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }